import * as React from 'react'
import { forwardRef, useEffect, useState } from 'react'
import ClickToEdit from 'react-click-to-edit'

export const PrintContent = React.forwardRef<HTMLDivElement, any>(
  (props, ref) => {
    const { user, setEditMode, badgeBg } = props
    const { nameForBadge, profession, badgeAffiliation, institution, qrLabel, ticket } = user

    const renderField = (value, className = '') => (
      <ClickToEdit
        wrapperClass={`line ${className}`}
        initialValue={value}
        startEditing={() => {
          setEditMode(true)
        }}
        endEditing={() => {
          setEditMode(false)
        }}
      />
    )

    return (
      <div
        ref={ref}
        className="badgePrint"
        style={{
          width: '4in',
          height: '6in',
          boxSizing: 'border-box',
          padding: '2.8in 1cm 1cm 1cm',
          // Screen-only: the badge artwork is just an alignment guide against the
          // real pre-printed badge stock. It is hidden for print (see the
          // `.badgePrint` rule below), so only the name, affiliation and QR print.
          backgroundImage: badgeBg ? `url(${badgeBg})` : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          margin: 'auto',
        }}
      >
        <style type="text/css" media="print">
          {`
            @page { size: 4in 6in;
              margin: 0;
            }
            /* The badge artwork is a screen-only alignment guide; never print it
               (!important overrides the inline backgroundImage). */
            .badgePrint {
              background-image: none !important;
            }
            .line {
              font-family: Georgia, 'Times New Roman', serif;
              font-size: 12pt;
              display: block !important;
              margin-bottom: 1pt;
              text-align: center;
              line-height: 1;
            }
            .fullName {
              font-size: 20pt;
              font-weight: bold;
            }
            .role {
              font-style: italic;
              font-size: 15pt;
            }
            .CTE--wrapper:after {
              content: '' !important;
            }
            #qrLabel {
              display: block;
              width: 40%;
              margin-bottom: 6pt;
            }
            .ticket {
              font-size: 9pt;
              text-align: center;
            }
          `}
        </style>
        {/* <div className="imageGap"></div> */}
        {renderField(nameForBadge, 'fullName')}
        {renderField(badgeAffiliation, 'role')}
        <img id="qrLabel" src={qrLabel} />
        {/* {renderField(ticket, 'ticket')} */}
      </div>
    )
  }
)

// const PrintContent = forwardRef(PrintContentRef)
export default PrintContent
